// 常用提示语
const messageConfig = {
  ADD_SUCCESS:'新增成功！',
  PUT_SUCCESS:'修改成功！',
  OPERATION_SUCCESS:'操作成功！',
  DELETE_SELECT:'请勾选需要删除的数据！',//提示勾选数据
  DELETE_AFTER:'删除后不可恢复，确定删除吗？',//删除前提示语
  DELETE_SUCCESS:'删除成功！',
  EXPORT_SUCCESS:'导入成功！',
  TENANTGUID_SELECT:'请先选择所属企业',
  IMPORT_TENANTGUID:"请先选择导入企业",
  ORGANISATION_SELECT:'请先选择所属组织',
  FORM_CONFIG_WARNING:'功能界面内容未配置，请联系运营人员处理',
  NO_DATA:'暂无数据',
  MARK_DATA:'此操作将永久标记, 是否继续？',
  CANCEL_TIP:'已取消',
  UPLOAD_SUCCESS:'上传成功',
  SUBMIT_SUCCESS:'提交成功',
  IMPORT_HANDLE:'正在导入中无法下载',
  IMPORT_FILE_BROKEN:'文件已损坏，无法下载，请联系管理员！',
  //流程相关
  FLOW_PASS:'审批通过！',
  FLOW_REJECT:'驳回成功！',
  FLOW_CANCEL:'撤销成功！',
  FLOW_IS_CANCEL:'确定撤销吗?',
  FLOW_NO_ID:'未获取到流程信息',
};
  
  export default messageConfig;
  